import { FILTER_CHAT_ROOM_TABS } from "../../constants";
import { ChatsActionTypes, ADD_2S_TYPE, USER_DETAILS_TABS } from "./types";


// common success
export const chatsApiResponseSuccess = (actionType: string, data: any) => ({
  type: ChatsActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const chatsApiResponseError = (actionType: string, error: string) => ({
  type: ChatsActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getFavourites = () => ({
  type: ChatsActionTypes.GET_FAVOURITES,
});

export const getChatRoomLists = () => ({
  type: ChatsActionTypes.GET_CHAT_ROOM_LIST,
});

export const loadCustomerContent = (groupId: number) => ({
  type: ChatsActionTypes.LOAD_CUSTOMER_CONTENT,
  payload: groupId
});

export const getContentUnreadCount = (userOrGroupId: number, titleId: number) => ({
  type: ChatsActionTypes.GET_CONTENT_UNREAD_COUNT,
  payload: { userOrGroupId, titleId }
});

export const getAllContentCount = (userOrGroupId: number) => ({
  type: ChatsActionTypes.GET_CONTENT_UNREAD_COUNT_ALL,
  payload: { userOrGroupId }
});

export const getDirectMessages = () => ({
  type: ChatsActionTypes.GET_DIRECT_MESSAGES,
});

export const getChannels = () => ({
  type: ChatsActionTypes.GET_CHANNELS,
});

export const addContacts = (contacts: Array<string | number>) => ({
  type: ChatsActionTypes.ADD_CONTACTS,
  payload: contacts,
});

export const setPreviewAttachfile = (fileUrl: string) => ({
  type: ChatsActionTypes.SET_PREVIEW_ATTACHFILE,
  payload: fileUrl
})

export interface CreateChannelPostData {
  id: any;
  name: string;
  members: Array<string | number>;
  description?: string;
}
export const createChannel = (channelData: CreateChannelPostData) => ({
  type: ChatsActionTypes.CREATE_CHANNEL,
  payload: channelData,
});

export const changeSelectedChat = (selectedChat: string | number | null) => ({
  type: ChatsActionTypes.CHANGE_SELECTED_CHAT,
  payload: selectedChat,
});

export const changeSelectedContentTitle = (userOrGroupId: number, contentTitleId: number | null, caller: string) => ({
  type: ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE,
  payload: { userOrGroupId, selectedContentTitle: contentTitleId, caller },
});

export const changeSelectedContentTitleKeyId = (userOrGroupId: number, contentTitleId: number | null, keyId: any) => ({
  type: ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE_KEYID,
  payload: { userOrGroupId, contentTitleId, keyId },
});

export const reduceContentTitleUnread = (contentTitleId: number | null, keyId: any) => ({
  type: ChatsActionTypes.REDUCE_CONTENT_TITLE_UNREAD,
  payload: { contentTitleId, keyId },
});


export const getChatUserDetails = (selectedChat: string | number | null) => ({
  type: ChatsActionTypes.GET_CHAT_USER_DETAILS,
  payload: selectedChat,
});

export const getChatUserDetails2s = (selectedChat: string | number | null, addToChatRoomList: boolean, loadProfile: boolean, loadErp: boolean) => ({
  type: ChatsActionTypes.GET_CHAT_USER_DETAILS_2S,
  payload: { selectedChat: selectedChat, addToChatRoomList: addToChatRoomList, loadProfile, loadErp }
});

export const erpGetCustomerTask = (userOrGroupId: number) => ({
  type: ChatsActionTypes.ERP_GET_CUSTOMER_TASK,
  payload: { userOrGroupId: userOrGroupId }
})

export const erpGetPrevTopNoVolume = (userOrGroupId: number) => ({
  type: ChatsActionTypes.ERP_GET_PREV_TOP_NO_VOLUME,
  payload: { userOrGroupId: userOrGroupId }
})

export const erpCateSizeNotSaleMoreThan45 = (userOrGroupId: number) => ({
  type: ChatsActionTypes.ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45,
  payload: { userOrGroupId: userOrGroupId }
})

export const erpCateInterestNotSale = (userOrGroupId: number) => ({
  type: ChatsActionTypes.ERP_CATE_INTEREST_NOT_SALE,
  payload: { userOrGroupId: userOrGroupId }
})

export const erpCateNotSaleMoreThan60 = (userOrGroupId: number) => ({
  type: ChatsActionTypes.ERP_CATE_NOT_SALE_MORE_THAN_60,
  payload: { userOrGroupId: userOrGroupId }
})


export const getLastGroupChatInfoOfMember = (userOrGroupId: number) => ({
  type: ChatsActionTypes.GET_LAST_GROUP_CHAT_INFO_OF_MEMBER,
  payload: { userOrGroupId: userOrGroupId }
});

export const delUserFromGroup = (groupId: number, memberId: number) => ({
  type: ChatsActionTypes.DEL_USER_FROM_GROUP,
  payload: { groupId, memberId }
})

export const addUserToGroup = (groupId: number, memberId: number, isAdd: boolean) => ({
  type: ChatsActionTypes.ADD_USER_TO_GROUP,
  payload: { groupId, memberId, isAdd }
})

export const viewMsgMember = (msgId: string) => ({
  type: ChatsActionTypes.VIEW_MSG_MEMBER,
  payload: { msgId: msgId }
})

export const getChatUserConversations2 = (selectedChat: string | number | null, sendDateTime?: string | null, direction?: number | null, isFromSearch?: boolean | null, searchMsgId?: string | null, markAllAsRead?: boolean | null, callFrom?: string | null) => ({
  type: ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS,
  payload: { id: selectedChat, sendDateTime: sendDateTime, direction: direction, isFromSearch, searchMsgId, markAllAsRead, callFrom },
});

export const getChatUserConversationsPrev = (selectedChat: string | number | null, minDateTime?: string | null) => ({
  type: ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_PREV,
  payload: { id: selectedChat, minDateTime: minDateTime },
});

export const getChatUserConversationsNext = (selectedChat: string | number | null, maxDateTime?: string | null) => ({
  type: ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_NEXT,
  payload: { id: selectedChat, maxDateTime: maxDateTime },
});

export const toggleUserDetailsTab = (value: boolean) => ({
  type: ChatsActionTypes.TOGGLE_USER_DETAILS_TAB,
  payload: value,
});

export const onSendMessage = (data: any) => ({
  type: ChatsActionTypes.ON_SEND_MESSAGE,
  payload: data,
});

export const receiveMessage = (id: number | string) => ({
  type: ChatsActionTypes.RECEIVE_MESSAGE,
  payload: id,
});

export const readMessage = (id: number | string) => ({
  type: ChatsActionTypes.READ_MESSAGE,
  payload: id,
});

export const deleteMessage2s = (id: string) => ({
  type: ChatsActionTypes.DELETE_MESSAGE_2S,
  payload: id
});

export const addMessage2s = (message: any, addType: ADD_2S_TYPE) => ({
  type: ChatsActionTypes.ADD_MESSAGE_2S,
  payload: { message, addType }
});

export const receiveMessageFromUser = (id: number | string) => ({
  type: ChatsActionTypes.RECEIVE_MESSAGE_FROM_USER,
  payload: id,
});

export const updateUnreadCount = (userOrGroupId: number, unreadCount: number, unreadTagMe: number, lastChatText: any, lastChatTime: any) => ({
  type: ChatsActionTypes.UPDATE_UNREAD_COUNT,
  payload: { userOrGroupId, unreadCount, unreadTagMe, lastChatText, lastChatTime }
});

export const updateReadPcntOnMsg = (msgs: any[]) => ({
  type: ChatsActionTypes.UPDATE_READ_PCNT_ON_MSG,
  payload: msgs
})

export const deleteMessage = (
  userId: number | string,
  messageId: number | string
) => ({
  type: ChatsActionTypes.DELETE_MESSAGE,
  payload: { userId, messageId },
});

export const forwardMessage = (data: object) => ({
  type: ChatsActionTypes.FORWARD_MESSAGE,
  payload: data,
});

export const deleteUserMessages = (userId: number | string) => ({
  type: ChatsActionTypes.DELETE_USER_MESSAGES,
  payload: userId,
});

export const getChannelDetails = (id: number | string) => ({
  type: ChatsActionTypes.GET_CHANNEL_DETAILS,
  payload: id,
});

export const toggleFavouriteContact = (id: number | string) => ({
  type: ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT,
  payload: id,
});

export const getArchiveContact = () => ({
  type: ChatsActionTypes.GET_ARCHIVE_CONTACT,
});

export const toggleArchiveContact = (id: number | string) => ({
  type: ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT,
  payload: id,
});

export const readConversation = (id: number | string) => ({
  type: ChatsActionTypes.READ_CONVERSATION,
  payload: id,
});

export const deleteImage = (
  userId: number | string,
  messageId: number | string,
  imageId: number | string
) => ({
  type: ChatsActionTypes.DELETE_IMAGE,
  payload: { userId, messageId, imageId },
});

export const setGroupInviteCode2 = (code: string) => ({
  type: ChatsActionTypes.SET_GROUP_INVITE_CODE,
  payload: code
})

export const setTypingText = (selectedChat: any, typingText: any) => ({
  type: ChatsActionTypes.SET_TYPING_TEXT,
  payload: { selectedChat, typingText },
})

export const setTypingTag = (selectedChat: any, tagFormat: any) => ({
  type: ChatsActionTypes.SET_TYPING_TAG,
  payload: { selectedChat, tagFormat },
})

export const updateSenderInfo = (senderId: number, profileImage: string) => ({
  type: ChatsActionTypes.UPDATE_SENDER_INFO,
  payload: { senderId, profileImage },
})

export const setRespEmoji = (msgId: any, emojiName: any, emojiSymbol: any, currentMemberName: string) => ({
  type: ChatsActionTypes.SET_RESP_EMOJI,
  payload: { msgId, emojiName, emojiSymbol, currentMemberName }
})

export const setRespEmojiWhMsg = (msgId: any, respEmoji: any) => ({
  type: ChatsActionTypes.SET_RESP_EMOJI_WHMSG,
  payload: { msgId, respEmoji }
})

export const unsendMessage = (msgId: any) => ({
  type: ChatsActionTypes.UNSEND_MESSAGE,
  payload: { msgId }
})

export const updateSentFlag = (msgId: any) => ({
  type: ChatsActionTypes.UPDATE_SENT_FLAG,
  payload: { msgId }
})

export const changeGroupFullName = (groupId: any, fullName: any) => ({
  type: ChatsActionTypes.CHANGE_GROUP_FULL_NAME,
  payload: { groupId, fullName }
})

export const setProfileActiveTab = (tab: USER_DETAILS_TABS) => ({
  type: ChatsActionTypes.SET_PROFILE_ACTIVE_TAB,
  payload: { tab }
})

export const findForFilterChatroomSale = (notYetRead: boolean | null, personUnRead: boolean | null, noActivity: boolean | null, topRow: number, keyword: string | null) => ({
  type: ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_SALE,
  payload: { notYetRead, personUnRead, noActivity, keywordMode: FILTER_CHAT_ROOM_TABS.SALES, topRow, keyword }
})

export const findForFilterChatroomCs = (notYetRead: boolean | null, personUnRead: boolean | null, noActivity: boolean | null, topRow: number, keyword: string | null) => ({
  type: ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_CS,
  payload: { notYetRead, personUnRead, noActivity, keywordMode: FILTER_CHAT_ROOM_TABS.CS, topRow, keyword }
})

export const findForFilterChatroomProvince = (notYetRead: boolean | null, personUnRead: boolean | null, noActivity: boolean | null, topRow: number, keyword: string | null) => ({
  type: ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_PROVINCE,
  payload: { notYetRead, personUnRead, noActivity, keywordMode: FILTER_CHAT_ROOM_TABS.PROVINCE, topRow, keyword }
})

export const updateImageRotateInfo = (mId: string, fileId: string, downloadLink: string, downloadThumb: string, degree: number) => ({
  type: ChatsActionTypes.UPDATE_IMAGE_ROTATE_INFO,
  payload: { mId, fileId, downloadLink, downloadThumb, degree }
})

export const searchChat = (userOrGroupId: number, page: number, keyword: string) => ({
  type: ChatsActionTypes.SEARCH_CHAT,
  payload: { userOrGroupId, page, keyword }
})

export const quickReplyLoadAll = () => ({
  type: ChatsActionTypes.QUICK_REPLY_LOAD_ALL,
  payload: {}
})

export const quickReplySetCount = (quickReplyId: number, count: number) => ({
  type: ChatsActionTypes.QUICK_REPLY_SET_COUNT,
  payload: { quickReplyId, count }

})